"use client";

import { default as NextImage } from "next/image";
import ProductPage from "@/components/ProductPage";
import Section from "@/components/Section";

// Bilder
import TeamViewver from "./TeamViewver.webp";
import RustDesk from "./RustDesk.webp";
import anydesk from "@/app/support/anydesk.webp";
import ImageHero from "./support1.webp";

export default function Support() {
  return (
    <ProductPage
      productName="Kontakt & Support – SDI Group"
      hero={{
        title: "Kontakt & Support",
        subtitle:
          "Sie erreichen unser Support-Team während unserer Geschäftszeiten.",
        buttonLeft: {
          title: "Jetzt anrufen",
          href: "tel:+49 (0) 6196 - 950 591 0",
        },
        buttonRight: {
          title: "E-Mail schreiben",
          href: "mailto:info@sdigroup.de",
        },
        image: ImageHero,
        imageAlt: "Kontakt & Support",
      }}
      highlight={{
        image: ImageHero,
        bullets: [
          <>
            <strong>Montag – Freitag</strong> von 09:30 – 13:00 und 14:00 –
            18:00 Uhr erreichbar.
          </>,
          <>
            <strong>Fernwartung</strong> – sicher und nur mit Ihrer Erlaubnis.
          </>,
          <>
            <strong>Schnelle Hilfe</strong> per Telefon, E-Mail oder
            Remote-Zugriff.
          </>,
        ],
      }}
      beforeVideo={
        <>
          {/* FERNWARTUNG HEADER */}
          <section className="bg-black text-white text-center py-10 px-4">
            <p className="text-xl max-w-4xl mx-auto">
              Sie behalten die Kontrolle. Unsere Fernwartung lässt uns nur auf
              Ihren Rechner zugreifen, wenn Sie das explizit erlauben.
            </p>
          </section>

          <Section className="bg-white py-16">
            <h2 className="text-3xl text-center mb-16 font-semibold text-slate-900">
              Sicherer Remote Access
            </h2>

            <div className="max-w-4xl mx-auto space-y-24">
              {/* TeamViewer */}
              <div className="grid grid-cols-1 md:grid-cols-2 gap-10 items-center">
                <div className="flex justify-center md:justify-start">
                  <NextImage src={TeamViewver} alt="TeamViewer" width={250} />
                </div>
                <div className="flex flex-col items-center md:items-start text-center md:text-left">
                  <a
                    href="https://s3.sdigroup.de/sdigroup/GSDI-Fernwartung.exe"
                    className="bg-brand-primary text-white text-center rounded-full font-bold text-sm tracking-widest transition-all w-full sm:w-auto px-5 py-3 lg:px-8 lg:py-4 hover:bg-brand-primary-dark hover:-translate-y-1 hover:shadow-xl"
                  >
                    TeamViewer herunterladen
                  </a>
                  <p className="mt-6 text-slate-700">
                    Etablierte Lösung für schnellen Support und Online-Meetings.
                  </p>
                </div>
              </div>

              {/* RustDesk */}
              <div className="grid grid-cols-1 md:grid-cols-2 gap-10 items-center">
                <div className="flex justify-center md:justify-start">
                  <NextImage src={RustDesk} alt="RustDesk" width={300} />
                </div>
                <div className="flex flex-col items-center md:items-start text-center md:text-left">
                  <a
                    href="https://s3.sdigroup.de/sdigroup/GSDI-Fernwartung-x86_64.exe"
                    className="bg-brand-primary text-white text-center rounded-full font-bold text-sm tracking-widest transition-all w-full sm:w-auto px-5 py-3 lg:px-8 lg:py-4 hover:bg-brand-primary-dark hover:-translate-y-1 hover:shadow-xl"
                  >
                    RustDesk herunterladen
                  </a>
                  <p className="mt-6 text-slate-700">
                    Open-Source-Alternative mit Fokus auf Datenschutz.
                  </p>
                </div>
              </div>

              {/* AnyDesk */}
              <div className="grid grid-cols-1 md:grid-cols-2 gap-10 items-center">
                <div className="flex justify-center md:justify-start">
                  <NextImage src={anydesk} alt="AnyDesk" width={300} />
                </div>
                <div className="flex flex-col items-center md:items-start text-center md:text-left">
                  <a
                    className="bg-brand-primary text-white text-center rounded-full font-bold text-sm tracking-widest transition-all w-full sm:w-auto px-5 py-3 lg:px-8 lg:py-4 hover:bg-brand-primary-dark hover:-translate-y-1 hover:shadow-xl"
                    href="/downloads/AnyDesk.exe"
                    download
                  >
                    AnyDesk herunterladen
                  </a>
                  <p className="mt-6 text-slate-700">
                    Schnelle und sichere Remote-Support-Lösung.
                  </p>
                </div>
              </div>
            </div>
          </Section>
        </>
      }
      faqs={[
        {
          q: "Wie funktioniert die Fernwartung?",
          a: "Wir nutzen TeamViewer, AnyDesk und RustDesk für die Fernwartung. Ein Zugriff auf Ihren Rechner erfolgt ausschließlich mit Ihrer ausdrücklichen Erlaubnis – Sie behalten jederzeit die volle Kontrolle.",
        },
        {
          q: "Welche Fernwartungssoftware wird benötigt?",
          a: "Je nach Situation verwenden wir TeamViewer, RustDesk oder AnyDesk. Unser Support-Team teilt Ihnen bei Bedarf mit, welches Tool im jeweiligen Fall zum Einsatz kommt.",
        },
        {
          q: "Wie schnell erhalte ich eine Antwort per E-Mail?",
          a: "Wir bemühen uns, alle E-Mail-Anfragen so schnell wie möglich zu beantworten – in der Regel noch am selben Werktag.",
        },
        {
          q: "Kann ich auch außerhalb der Geschäftszeiten Kontakt aufnehmen?",
          a: "Ja, per E-Mail an info@sdigroup.de – wir melden uns dann am nächsten Werktag bei Ihnen.",
        },
        {
          q: "Ist die Fernwartung sicher?",
          a: "Ja, alle von uns eingesetzten Tools – TeamViewer, RustDesk und AnyDesk – nutzen verschlüsselte Verbindungen. Zudem wird jede Sitzung nur auf Ihre Anfrage hin gestartet.",
        },
      ]}
      features={[]}
    />
  );
}
